import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEqual } from "lodash";
import React, { memo } from "react";
import TimeInfo from "./TimeInfo";
import VolumeButton from "./controls/VolumeButton";
var PlayerControls = function(param) {
    var videoPlayer = param.videoPlayer, actions = param.actions, currentTime = param.currentTime, i18n = param.i18n, screenType = param.screenType, playbackButtons = param.playbackButtons;
    if (videoPlayer.video.source.length === 0) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "controls",
        style: {
            width: videoPlayer.isVod && "100%"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "controls-wrapper",
                children: [
                    playbackButtons,
                    /*#__PURE__*/ _jsx(VolumeButton, {
                        i18n: i18n,
                        screenType: screenType,
                        videoPlayer: videoPlayer,
                        actions: actions
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "current-title",
                children: videoPlayer.epgs.current.title
            }),
            /*#__PURE__*/ _jsx(TimeInfo, {
                videoPlayer: videoPlayer,
                currentTime: currentTime
            })
        ]
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(PlayerControls, areEqual);
